<template>
    <div class="app-card">
        <avatar :url="item.logo"></avatar>
        <div class="info">
            <p class="name">{{item.name}}</p>
            <p class="id">ID: {{item.appId}}</p>
            <p class="id">Vapp ID: {{item.vAppId}}</p>
        </div>
        <div class="edit-btn" v-if="item.origin === 0">
            <div @click="cancelConnection" class="unactive sub-action">取消关联</div>
            <div @click="dialogVisible = true" class="sub-action">详情</div>
        </div>
         <div class="edit-btn" v-if="item.origin === 1">
            <div @click="dialogVisible = true" class="sub-action game-btn">详情</div>
        </div>
        <up-edit-dialog v-if="dialogVisible" :item="item" :visible.sync="dialogVisible"></up-edit-dialog>
    </div>
</template>
<script>
import Avatar from '@/components/Avatar.vue';
import UpEditDialog from '@/components/UpEditDialog.vue';
import dao from '@/lib/dao.js';
export default {
    components: {
        Avatar,
        UpEditDialog
    },
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialogVisible: false
        }
    },
    methods: {
        cancelConnection() {
            this.$confirm('确认取消关联吗?取消后你的账号将与小程序解除合作关系', '取消关联', {
                confirmButtonText: '取消关联',
                cancelButtonText: '放弃',
                type: 'warning'
            }).then(() => {
                dao.up.upStatusUpdate({
                    appId: this.item.vAppId,
                    status: 13
                }).then(data => {
                    this.$emit('refresh');
                }).catch(msg => {
                    this.$message.error(msg);
                }); 
            }).catch(() => {
            });
        }
    }
}
</script>
<style lang="less" scoped>
.app-card {
    width: 339px;
    height: 120px;
    border: 1px solid #E0E5EC;
    border-radius: 4px;
    padding: 12px 12px 0 12px;
    position: relative;

    .info {
        display: inline-block;
        vertical-align: top;
        //padding-top: 10px;
        margin-left: 12px;
        
        .name {
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 500;
        }
        .id {
            font-size: 14px;
            line-height: 20px;
        }
    }
    .edit-btn {
        margin-top: 15px;
        font-size: 14px;
        color: #789AFF;
        line-height: 20px;
        font-size: 0;

        .sub-action {
            display: inline-block;
            width: 50%;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
            &.unactive {
                color: #5C667E;
            }
            &.game-btn {
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UpSmallAppCard.vue